import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Button from "react-bootstrap/Button";
import styles from "../../../styles/CompanyAdminPanel.module.scss";
import { toast } from "react-hot-toast";
import Index from "../main/Index";
import InvalidToken from "../InvalidToken";
import API from "../../../lib/api";

function ResetPassword({ token }) {
  const [login, setLogin] = useState(false);
  const [initialEmail,setInitialEmail]=useState("")
  const [invalidtoken,setInvalidToken] = useState(false)

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const response = await API.post(
          "/api/user/verify-user/",
          { token }
        );
        // console.log(response.data.message);
        toast.success(response.data.status);
        console.log(response.data,"data")
        setInitialEmail(response.data.user_email)
        if (response.data.message === "Password set successfully"){
          setLogin(true)
        }
      } catch (error) {
        if (error.response && error.response.data.message === "invalid token") {
          setInvalidToken(true);
        }     
        else {
          toast.error(error.response.data.status);
          setInitialEmail(error.response.data.client_mail)
          // console.log(error);
        }
      }
    };

    verifyToken();
  }, [token]);

  const validationSchema = Yup.object().shape({
    password: Yup.string().required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const handleSubmit = async (values) => {
    try {
      const response = await API.post(
        "/api/client/set-password",
        {
          email:initialEmail,
          password: values.password,
        }
      );
      // console.log(response.data.message);
      toast.success("Password updated successfully");
      console.log(response)
      setLogin(true);
    } catch (error) {
      toast.error("Something went wrong");
      // console.log(error);
    }
  };

  if (login) {
    return <Index />;
  }
  if(invalidtoken){
    return <InvalidToken/>
  }

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className={`${styles.verifyPass} px-4 pt-4 mb-5`}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ touched, errors }) => (
            <Form>
              <div className="mb-3">
                <label htmlFor="password">New Password</label>
                <Field
                  type="password"
                  id="password"
                  name="password"
                  className={`form-control ${
                    touched.password && errors.password ? "is-invalid" : ""
                  }`}
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-danger"
                />
              </div>

              <div className="mb-3">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <Field
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  className={`form-control ${
                    touched.confirmPassword && errors.confirmPassword
                      ? "is-invalid"
                      : ""
                  }`}
                />
                <ErrorMessage
                  name="confirmPassword"
                  component="div"
                  className="text-danger"
                />
              </div>

              <Button variant="primary" type="submit" className="mb-5">
                Submit
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default ResetPassword;
